import {NgModule} from "@angular/core";
import {IntIpAddressComponent} from "./int-ip-address.component";
import {CommonModule} from "@angular/common";
import {IntClosedTagModule, IntEmptyDividerModule, IntIconModule, IntLabeledFieldBoxModule} from "../../components";
import {FormsModule} from "@angular/forms";


@NgModule({
  imports: [
    CommonModule,
    IntLabeledFieldBoxModule,
    IntClosedTagModule,
    FormsModule,
    IntEmptyDividerModule,
    IntIconModule
  ],
  declarations: [
    IntIpAddressComponent
  ],
  exports: [
    IntIpAddressComponent
  ]
})
export class IntIpAddressModule {}
